import PropTypes from 'prop-types'
import css from '../info-fields.css'

const SourceURL = ({ value = '', onChange }) => (
    <div className={css.field}>
        <label className={css.label}>Source URL</label>
        <input
            className={css.input}
            type="url"
            value={value}
            placeholder="Enter a source"
            onChange={(e) => onChange({ sourceUrl: e.target.value })}
        />
    </div>
)

SourceURL.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
}

export default SourceURL
